import React from 'react';
import { Tooltip as ReactTooltip, ITooltip } from 'react-tooltip';

const CustomTooltip: React.FC<ITooltip> = ({
  place,
  className,
  noArrow,
  id,
  content,
  anchorSelect,
  isOpen,
  html,
  children,
  delayShow,
  ...rest
}) => {
  return (
    <ReactTooltip
      {...rest}
      id={id}
      anchorSelect={anchorSelect}
      place={place}
      content={content}
      noArrow={noArrow}
      isOpen={isOpen}
      html={html}
      className={className}
      delayShow={delayShow}
    >
      {children}
    </ReactTooltip>
  );
};

export default CustomTooltip;
